import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import VoucherService from '../../../../services/vouchers/voucherService';
import './listVoucher.scss';

class ListVoucher extends Component {
    constructor() {
        super();
        this.state = {
            vouchers: [],
            isLoading: true,
            searchKey: '',
            skipCount: 0,
            maxResultCount: 20,
            totalVoucher: 0,
            pageNo: 1,
        };
        this.syncVouchers = this.syncVouchers.bind(this);
        this.handleClickPrev = this.handleClickPrev.bind(this);
        this.handleClickNext = this.handleClickNext.bind(this);
        this.handleClickRow = this.handleClickRow.bind(this);
        this.redirectToAddVoucher = this.redirectToAddVoucher.bind(this);
    }

    componentDidMount() {
        this.syncVouchers();
    }

    syncVouchers() {
        this.setState({ isLoading: true });
        VoucherService.GetAll(this.state.searchKey, this.state.skipCount, this.state.maxResultCount).then(res => {
            this.setState({
                vouchers: res.data.result.items,
                totalVoucher: res.data.result.totalCount,
                totalPage: Math.ceil(res.data.result.totalCount / this.state.maxResultCount)
            });
        }).finally(() => {
            this.setState({ isLoading: false });
        });
    }

    handleClickPrev() {
        if (this.state.pageNo > 1) {
            var pageNo = this.state.pageNo - 1;
            this.setState({
                pageNo: pageNo,
                skipCount: (pageNo - 1) * this.state.maxResultCount
            }, () => {
                this.syncVouchers();
            })
        }
    }

    handleClickNext() {
        if (this.state.pageNo < this.state.totalPage) {
            var pageNo = this.state.pageNo + 1;
            this.setState({
                pageNo: pageNo,
                skipCount: (pageNo - 1) * this.state.maxResultCount
            }, () => {
                this.syncVouchers();
            });
        }
    }

    handleClickRow(voucher) {
        this.props.history.push("/admin/vouchers/edit/" + voucher.id);
    }

    redirectToAddVoucher() {
        this.props.history.push('/admin/vouchers/add');
    }

    render() {
        const { isLoading, vouchers, pageNo, totalPage, totalVoucher } = this.state;
        return (
            <div className="search-results-wrapper is-admin-order-table banking-dashboard banking-dashboard-v3">
                <div className="search-results-body">
                    <div className="columns">
                        <div className="column">
                            <div className="tabs-wrapper">
                                <div className="tabs-inner">
                                    <div className="tabs-inner is-clearfix">
                                        <h3 className='title is-thin is-5 is-pulled-left p-2 is-hidden-mobile'>Vouchers</h3>
                                        <h3 className='title is-thin is-5 p-2 is-hidden-desktop'>Vouchers</h3>
                                        <div className="tabs is-toggle is-pulled-right is-right">
                                            <button className="button h-button is-primary is-raised" onClick={this.redirectToAddVoucher}>
                                                <span className="icon">
                                                    <i className="fas fa-plus"></i>
                                                </span>
                                                <span>Buat Voucher Baru</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className={"flex-table is-compact has-loader " + (isLoading ? "has-loader-active min-height" : "")}>
                                        <div className="flex-table-header">
                                            <span className="flex-medium">Nama</span>
                                            <span className="flex-medium">Kode Voucher</span>
                                            <span className="flex-medium">Diskon</span>
                                            <span className="">Tipe Produk</span>
                                            <span className="flex-medium">Kadarluasa</span>
                                            <span className="flex-small">Status</span>
                                            <span className="flex-small"></span>
                                        </div>
                                        {
                                            !isLoading ?
                                                (
                                                    (vouchers.length > 0) ?
                                                        vouchers.map((voucher, index) => (
                                                            <div className='flex-table-item' key={index}>
                                                                <div className="flex-table-cell flex-medium" data-th="Nama">
                                                                    <span className="light-text">
                                                                        <a href={"/admin/vouchers/" + voucher.id}
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                this.handleClickRow(voucher)
                                                                            }}>
                                                                            <span className="dark-text has-text-weight-medium">
                                                                                {voucher.name}
                                                                            </span>
                                                                        </a>
                                                                    </span>
                                                                </div>
                                                                <div className="flex-table-cell flex-medium" data-th="Kode Voucher">
                                                                    <span className="">{voucher.voucherCode}</span>
                                                                </div>
                                                                <div className="flex-table-cell flex-medium" data-th="Diskon">
                                                                    <span className="">
                                                                        {
                                                                            voucher.isPercentage ?
                                                                                <span>{voucher.value * 100}%</span>
                                                                                :
                                                                                <NumberFormat value={voucher.value} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                                                                        }
                                                                    </span>
                                                                </div>
                                                                <div className="flex-table-cell" data-th="Tipe Produk">
                                                                    <span className="">{voucher.isForAllProduct ? "Semua Produk" : voucher.productType.name}</span>
                                                                </div>
                                                                <div className="flex-table-cell flex-medium" data-th="Kadarluasa">
                                                                    <span className="">{voucher.isCanExpire ? moment(voucher.expiryDate).local().format('LLL') : 'Selamanya'}</span>
                                                                </div>
                                                                <div className="flex-table-cell flex-small" data-th="Status">
                                                                    <span className="light-text">
                                                                        <span className={"tag is-rounded " + (voucher.isActive ? "is-success" : "is-danger")}>{voucher.isActive ? "Aktif" : "Tidak Aktif"}</span>
                                                                    </span>
                                                                </div>
                                                                <div className="flex-table-cell flex-small" data-th="">
                                                                    <a href={"/admin/vouchers/edit/" + voucher.id} target="_blank" onClick={(e) => { e.preventDefault(); this.handleClickRow(voucher) }} rel="noreferrer" className="button is-dark-outlined">Edit</a>
                                                                </div>
                                                            </div>
                                                        )
                                                        ) :
                                                        <div className="section-placeholder">
                                                            <div className="placeholder-content">
                                                                <img className="light-image" src="images/illustrations/placeholders/search-4.svg" alt="" />
                                                                <img className="dark-image" src="images/illustrations/placeholders/search-4-dark.svg" alt="" />
                                                                <h3 className="dark-inverted">Tidak ada Voucher</h3>
                                                                <p>Saat ini belum ada Voucher yang bisa ditampilkan.</p>
                                                            </div>
                                                        </div>
                                                )
                                                :
                                                <div className="h-loader-wrapper">
                                                    <div className="loader is-large is-loading"></div>
                                                </div>
                                        }
                                    </div>

                                    {
                                        totalPage > 0 ?
                                            <div className="is-clearfix">
                                                <div className="buttons has-addons is-scrollable mt-2 mb-0 is-pulled-left">
                                                    {
                                                        pageNo === 1 ? <></> : <button className={"button h-button is-raised"} onClick={this.handleClickPrev}>Prev</button>
                                                    }
                                                    {
                                                        pageNo === totalPage ? <></> : <button className={"button is-primary h-button is-raised"} onClick={this.handleClickNext}>Next</button>
                                                    }
                                                </div>
                                                <div className="is-pulled-left mt-3">
                                                    <span className="ml-3 dark-inverted">Total Voucher: {totalVoucher}, page {pageNo} of {totalPage}</span>
                                                </div>
                                            </div>
                                            :
                                            <></>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(ListVoucher);